/*
 * Copyright (c) 2021. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import LandingPageTeaser from "../../../../../components/Teaser/LandingPageTeaser";
import Container from "../../../../../components/Container/Container";
import TrafficCheckin from "../../../../../components/Checkin/TrafficCheckin/TrafficCheckin";
import IncorrectPenaltySection from "../../../../../components/Sections/Traffic/IncorrectPenaltySection/IncorrectPenaltySection";
import AttorneySection from "../../../../../components/Sections/Generic/AttorneySection/AttorneySection";
import AdvantagesLegalbirdAttorneySection from "../../../../../components/Sections/Generic/AdvantagesLegalbirdAttorneySection/AdvantagesLegalbirdAttorneySection";
import TrustSection from "../../../../../components/Sections/Generic/TrustSection/TrustSection";
import TrafficCostRiskSection from "../../../../../components/Sections/Traffic/TrafficCostRiskSection/TrafficCostRiskSection";
import { getLastPathSplit } from "../../../../../services/redirect";
import { landingPagesList } from "../../../../../services/landingPagesList";
import Layout from "../../../../Layouts/Layout";
import LpRedLightMeta from "./LpRedLightMeta";
import PartnersSection from "../../../../../components/Sections/Generic/PartnersSection/PartnersSection";
import { trafficTeaserCards } from "../../../../../services/landingPageService";
import LinkedCardBox from "../../../../../components/LinkedCardBox/LinkedCardBox";
import GreyBackgroundWrapper from "../../../../../components/BackgroundWrapper/GreyBackgroundWrapper";
import { useLocation } from "react-router";
import { useCustomer } from "../../../../../provider/Customer/CustomerProvider";
import HowItWorksSectionTraffic
  from "../../../../../components/Sections/Traffic/HowItWorksSection/HowItWorksSectioTraffic";

const LpRedLight = () => {
  const accusationData = {
    name: "redLight",
    detail: {
      name: "redLight.roadUsersEndangered",
      label: "Verkehrsteilnehmer gefährdet? ",
      options: [
        { value: "yes", label: "Ja" },
        { value: "no", label: "Nein" },
        { value: "unknown", label: "Ich bin mir nicht sicher" },
      ],
    },
  };

  const location = useLocation();
  const lpKey = getLastPathSplit(location.pathname);
  const keyword = (lpKey && landingPagesList[lpKey]?.keyword) ?? "Rotlichtverstoß";
  const headline = (lpKey && landingPagesList[lpKey]?.headline) ?? "Rote Ampel überfahren?";
  const { isLoggedIn } = useCustomer();

  return (
    <Layout minimal={!isLoggedIn} clickableLogo={isLoggedIn} backgroundType={"landingpage"}>
      <LpRedLightMeta keyword={keyword} />
      <LandingPageTeaser
        headline={headline}
        subheadline={"Jetzt effektiv gegen Bußgeld, Punkte oder Fahrverbot vorgehen!"}
        teaserButtonText={"Kostenlose Ersteinschätzung"}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox linkedCards={trafficTeaserCards} />
      </LandingPageTeaser>
      <GreyBackgroundWrapper>
        {!isLoggedIn && (
          <Container>
            <TrafficCheckin idPrefix={"top"} checkinHeading={"Wir geben Ihnen eine kostenlose Ersteinschätzung"} accusation={accusationData} />
          </Container>
        )}
        <IncorrectPenaltySection />
      </GreyBackgroundWrapper>
      <HowItWorksSectionTraffic />
      <TrafficCostRiskSection />
      <GreyBackgroundWrapper>
        <AttorneySection
          product={"traffic"}
          textCards={false}
          subheading={"Sie möchten professionell und unkompliziert gegen Ihren Bescheid vorgehen? Wir helfen Ihnen - jederzeit und ortsunabhängig!"}
        />
        <AdvantagesLegalbirdAttorneySection product={"traffic"} />
      </GreyBackgroundWrapper>
      <TrustSection />
      {!isLoggedIn && (
        <Container>
          <TrafficCheckin idPrefix={"bottom"} checkinHeading={"Wir geben Ihnen eine kostenlose Ersteinschätzung"} accusation={accusationData} />
        </Container>
      )}
      <PartnersSection />
    </Layout>
  );
};

export default LpRedLight;
